// API Base URL - defaults to empty string for Netlify Functions
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// In production on Netlify, API calls will go to the same domain via /.netlify/functions/
// In development, they'll go to the local Express server